import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../store/auth.store';
import { usePermission } from './usePermission';
import { fetchScopedConfig } from '../api/config-scope.api';

/**
 * `fsma.enabled` de la empresa. Comparte la caché de `useTenantConfig`.
 * Falla cerrada: sin permiso de lectura de configuración o con error, es false.
 */
export function useFsmaEnabled(): boolean {
  const tenantId = useAuthStore(s => s.user?.tenantId);
  const canReadConfig = usePermission('config:read');
  const { data } = useQuery({
    queryKey: ['tenant-config', tenantId],
    queryFn: () => fetchScopedConfig('TENANT', tenantId as string),
    enabled: !!tenantId && canReadConfig,
  });
  return data?.effective?.['fsma.enabled']?.value === true;
}
